/* eslint-disable no-console */
import debug from "debug";
import { isEnvironment } from "lib/utils/environment";
import { Environment } from "types/enums/environment";

export enum MonitoringServices {
  Sentry = "sentry",
}

interface Logger {
  log: debug.Debugger;
  error: debug.Debugger;
  info: debug.Debugger;
  trace: debug.Debugger;
  warn: debug.Debugger;
  debug: debug.Debugger;
}

const getLogger = (namespace: string): Logger => {
  const log = debug(`log:${namespace}`);

  log.log = console.log.bind(console);

  const error = debug(`error:${namespace}`);

  error.log = console.error.bind(console);

  const info = debug(`info:${namespace}`);

  info.log = console.info.bind(console);

  const consoleDebug = debug(`debug:${namespace}`);

  consoleDebug.log = console.debug.bind(console);

  const trace = debug(`trace:${namespace}`);

  trace.log = console.trace.bind(console);

  const warn = debug(`warn:${namespace}`);

  warn.log = console.warn.bind(console);

  return {
    log,
    error,
    info,
    trace,
    warn,
    debug: consoleDebug,
  };
};

const isDevelopment = !isEnvironment(Environment.Production);
const devNamespaces = process.env.DEBUG_LOGGER || "*";
const productionNamespaces = "warn:*,error:*";

debug.enable(isDevelopment ? devNamespaces : productionNamespaces);

export { getLogger };
